// extracted by mini-css-extract-plugin
export var carrierIcon = "_x3-0";
export var carrierLogo = "_x3-1";
export var detailsSection = "_x3-2";